import styled from 'styled-components'
import { space, color, borders, borderColor, focus, themeGet } from 'styled-system'

const Input = styled.input`
  outline: none;
  font-weight: 600;
  color: ${themeGet('colors.gray.1')};
  box-shadow: inset 1px 1px 10px rgba(0, 0, 0, 0.03);
  ::placeholder {
    font-weight: 200;
    color: ${themeGet('colors.gray.3')};
  }
  :focus {
    box-shadow: inset 1px 1px 10px rgba(0, 0, 0, 0.14);
  }
  ${space}
  ${color}
  ${focus}
  border: none;
  ${borders}
  ${borderColor}
`

Input.defaultProps = {
  // borderLeft: 4,
  borderColor: 'primary.0',
  bg: 'gray.5',
  p: 3,
}

export default Input



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Input.js